import Uppy from '@uppy/core'
import _ from 'underscore'
import mime from 'mime-types';
import AwsS3Multipart from '@uppy/aws-s3-multipart'
import queryString from 'query-string'

import mimeDB from '../routes/media/mime-db'
import { createRequestFn, slugify } from '../routes/media/util'
import createModels from '../routes/media/create-models'
import config from '../config'

mime(mimeDB)
const mimeLookup = mime(mimeDB)

var S3_BUCKET = 'invintus-uploads'
var CLIENT_IMAGES_BUCKET = 'invintus-client-images'

const { createIo } = createModels;
const { uris, apiAuthentication } = config;
var CRUD_URL = uris.crud;
const PULBLIC_URL = uris.public;

function createS3Key ({ clientID, eventID, fileName }) {
    var keyName = clientID + '/' + clientID + '_' +
            (eventID || 'MISC') + '_' + slugify(fileName)
    return keyName
}

function createApis({ clientID }) {
  var publicApi = createRequestFn({
      clientID: clientID,
      host: PULBLIC_URL,
      headers: {
          authorization: apiAuthentication.vendorName,
          "wsc-api-key": apiAuthentication.vendorKey,
      },
  });

  var crudApi = createRequestFn({
      clientID: clientID,
      host: CRUD_URL,
      headers: {
          authorization: apiAuthentication.vendorName,
          "wsc-api-key": apiAuthentication.vendorKey,
      },
  });

  return { publicApi, crudApi };
}

function createUppy ({ clientID }) {
    const apis = createApis({clientID})
    const io = createIo(apis)
    const models = createModels({io})
    const validateFile = apis.publicApi('/Console/preValidateUpload')
    var s3 = new window.AWS.S3({
        apiVersion: '2006-03-01',
        region: 'us-west-2',
        httpOptions: { timeout: 10 * (60 * 1000) }
    })

    var validated = []

    var uppy = new Uppy({
        autoProceed: false,
        allowMultipleUploads: true,

        // return false for everything, then after the api call resolves,
        // add the file if it is valid
        onBeforeFileAdded: function (file, allFiles) {
            // you can start an infinite loop without this check
            // because this hook is called when you use the addFile method
            if (_.contains(validated, file)) return
            validated.push(file)
            validateFile({
                // mimeType, fileSize, ext
                mimeType: file.type || mimeLookup.lookup(file.name),
                fileSize: Math.floor(file.data.size / 1024 / 1024),
                ext: _.last((file.name || '').split('.').filter(Boolean))
            }, function (err, res) {
                if (err) return uppy.info('Error validating file ' +
                    file.name)
                if (!res.data.valid) {
                    return uppy.info('Invalid file – ' + res.data.message)
                }
                uppy.addFile(file)

                // if the file meta has a callback function, call it
                if (file.meta && file.meta.callback) {
                    file.meta.callback(file, res, err)
                }
            })
            return false
        }
    })

    uppy.use(AwsS3Multipart, {
        id: 'AwsS3Multipart',
        limit: 0,
        createMultipartUpload: function (file) {
            var type = file.type || mime.lookup(file.name);
            
            // Determine which bucket and region to use based on file metadata
            const bucket = file.meta && file.meta.targetBucket === CLIENT_IMAGES_BUCKET ? 
                CLIENT_IMAGES_BUCKET : 
                S3_BUCKET;
            
            const region = file.meta && file.meta.targetRegion ? 
                file.meta.targetRegion : 
                'us-west-2';
            
            // Create new S3 client with target region
            const s3Client = new window.AWS.S3({
                apiVersion: '2006-03-01',
                region: region,
                httpOptions: { timeout: 10 * (60 * 1000) }
            });
            
            return s3Client.createMultipartUpload({
                Key: file.meta && file.meta.exactKey ? file.meta.exactKey : createS3Key({
                    clientID: clientID,
                    eventID: file.eventID || 'MISC',
                    fileName: file.name
                }),
                Bucket: bucket,
                ContentType: type + ';charset=utf-8'
            }).promise().then(function ({ Key, UploadId }) {
                return { key: Key, uploadId: UploadId }
            })
        },

        listParts: function (file, { key, uploadId }) {
            // Determine which bucket and region to use based on file metadata
            const bucket = file.meta && file.meta.targetBucket === CLIENT_IMAGES_BUCKET ? 
                CLIENT_IMAGES_BUCKET : 
                S3_BUCKET;
            
            const region = file.meta && file.meta.targetRegion ? 
                file.meta.targetRegion : 
                'us-west-2';
            
            // Create new S3 client with target region
            const s3Client = new window.AWS.S3({
                apiVersion: '2006-03-01',
                region: region,
                httpOptions: { timeout: 10 * (60 * 1000) }
            });
            
            return s3Client.listParts({
                Key: key,
                UploadId: uploadId,
                Bucket: bucket
            }).promise()
        },

        prepareUploadPart: function (file, partData) {
            // Determine which bucket and region to use based on file metadata
            const bucket = file.meta && file.meta.targetBucket === CLIENT_IMAGES_BUCKET ? 
                CLIENT_IMAGES_BUCKET : 
                S3_BUCKET;
            
            const region = file.meta && file.meta.targetRegion ? 
                file.meta.targetRegion : 
                'us-west-2';
            
            // Create new S3 client with target region
            const s3Client = new window.AWS.S3({
                apiVersion: '2006-03-01',
                region: region,
                httpOptions: { timeout: 10 * (60 * 1000) }
            });
            
            var url = s3Client.getSignedUrl('uploadPart', {
                Bucket: bucket,
                Key: partData.key,
                UploadId: partData.uploadId,
                PartNumber: partData.number,
                Body: '',
                Expires: 5 * 60
            })

            return Promise.resolve({ url })
        },

        abortMultipartUpload: function (file, { uploadId, key }) {
            // Determine which bucket and region to use based on file metadata
            const bucket = file.meta && file.meta.targetBucket === CLIENT_IMAGES_BUCKET ? 
                CLIENT_IMAGES_BUCKET : 
                S3_BUCKET;
            
            const region = file.meta && file.meta.targetRegion ? 
                file.meta.targetRegion : 
                'us-west-2';
            
            // Create new S3 client with target region
            const s3Client = new window.AWS.S3({
                apiVersion: '2006-03-01',
                region: region,
                httpOptions: { timeout: 10 * (60 * 1000) }
            });
            
            return s3Client.abortMultipartUpload({
                Bucket: bucket,
                Key: key,
                UploadId: uploadId
            }).promise()
        },

        completeMultipartUpload: function (file, opts) {
            var { uploadId, key, parts} = opts
            
            // Determine which bucket and region to use based on file metadata
            const bucket = file.meta && file.meta.targetBucket === CLIENT_IMAGES_BUCKET ? 
                CLIENT_IMAGES_BUCKET : 
                S3_BUCKET;
            
            const region = file.meta && file.meta.targetRegion ? 
                file.meta.targetRegion : 
                'us-west-2';
            
            // Create new S3 client with target region
            const s3Client = new window.AWS.S3({
                apiVersion: '2006-03-01',
                region: region,
                httpOptions: { timeout: 10 * (60 * 1000) }
            });
            
            return s3Client.completeMultipartUpload({
                Bucket: bucket,
                Key: key,
                UploadId: uploadId,
                MultipartUpload: {
                    Parts: parts
                }
            }).promise()
        }
    })

    uppy.on('file-removed', rmFileValidation)
    uppy.on('upload-success', rmFileValidation)

    function rmFileValidation (file) {
        var f = _.findWhere(validated, { data: file.data })
        if (!f) return
        var i = validated.indexOf(f)
        if (validated[i]) validated.splice(i, 1)
    }
    uppy.on("upload-error", (file, err) => {
      uppy.info("upload error:", err);
    });
    uppy.on("upload", (ev) => {
        ev.fileIDs.forEach((id) => {
            const file = uppy.getFile(id);
            const eventID = queryString.parse(window.location.search).eventID || 'MISC'
            file.eventID = eventID

            if (file.meta && file.meta.noPlaceholder) {
                return;
            }

            models.assets.getPlaceholder({
                eventID,
                fileName: slugify(file.name),
                fileSize: file.size,
            });
        });
    });
    return uppy
}

export default createUppy
